import React from 'react';
import ReactDOM from 'react-dom';
import {BrowserRouter as Router} from 'react-router-dom';
import './index.css';
import App from './App';
import Publisher from './Publisher'
import registerServiceWorker from './registerServiceWorker';

const Application = () => (
  <Router>
    <App />
  </Router>
)

ReactDOM.render(<Application />, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js